var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticStyle:{"width":"100%","height":"400px","background-color":"white"}}),_c('div',{staticStyle:{"width":"100%","height":"calc(100% - 500px)","overflow-y":"auto","margin-top":"10px"}})])
}]

export { render, staticRenderFns }